import { authRoleAccess } from "auth/AuthRoleAccess";
import { lazy } from "react";

const index = lazy(() => import("./index.jsx"));

const OfficerCaseReportingRoutes = [
  {
    path: "/officer-case-reporting",
    component: index,
    auth: authRoleAccess.officer_case_reporting,
  },
];

export default OfficerCaseReportingRoutes;
